import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { getIncidentById } from "../../api/api";
import { Link } from 'react-router-dom';

const IncidentDetail = () => {
  const { id } = useParams();
  const [incidentDetails, setIncidentDetails] = useState(null);

  useEffect(() => {
    // Fetch incident details
    const fetchIncidentDetails = async () => {
      try {
        const response = await getIncidentById(id);
        setIncidentDetails(response.data);
      } catch (error) {
        console.error("Error fetching incident details:", error);
      }
    };

    fetchIncidentDetails();
  }, [id]);

  if (!incidentDetails) {
    return <div>Loading...</div>;
  }

  const {
    sourceType,
    sourceId,
    cameraFeedUrl,
    workflowId,
    eventId,
    createdAt,
  } = incidentDetails;

  return (
    <div style={{ padding: "20px" }}>
      <Typography variant="h5" gutterBottom>
        Incident Details: {id}
      </Typography>

      <Grid container spacing={3}>
        {/* Incident Source Details */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Source Details
              </Typography>
              <List>
                <ListItem>
                  <ListItemText primary={`Source Type: ${sourceType}`} />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={
                      <Link to={`/asset/${sourceType}/${sourceId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                        Source ID: {sourceId}
                      </Link>
                    }
                  />
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Grid>

        {/* Recorded Previews */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Recorded Preview
              </Typography>
              <video
                controls
                src={cameraFeedUrl}
                style={{ width: "700px", height: "400px", borderRadius: "8px" }}
              />
            </CardContent>
          </Card>
        </Grid>

        {/* Workflow Details */}
        {workflowId && (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Workflow Details
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText primary={`Name: ${workflowId.name}`} />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={`Description: ${workflowId.description}`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={`Type: ${workflowId.type}`}
                      secondary={
                        workflowId.type === "global"
                          ? `Asset Type: ${workflowId.assetType}`
                          : "Local Workflow"
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary={`Status: ${workflowId.status}`} />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={`Created At: ${new Date(
                        workflowId.createdAt
                      ).toLocaleString()}`}
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
        )}

        {/* Event Details */}
        {eventId && (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Event Details
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText primary={`Type: ${eventId.type}`} />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={`Description: ${eventId.description}`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={`Source Type: ${eventId.sourceType}`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={`Created At: ${new Date(
                        eventId.createdAt
                      ).toLocaleString()}`}
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
        )}

        {/* Actions */}
        {workflowId?.actions && (
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Actions
                </Typography>
                <List>
                  {workflowId.actions.map((action, index) => (
                    <ListItem key={index}>
                      <ListItemText
                        primary={`Action ID: ${action}`}
                        secondary="Details can be fetched if available"
                      />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>
        )}

        {/* Incident Metadata */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Metadata
              </Typography>
              <List>
                <ListItem>
                  <ListItemText
                    primary={`Incident Created At: ${new Date(
                      createdAt
                    ).toLocaleString()}`}
                  />
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default IncidentDetail;
